import React, { useState } from "react";
import Header from "../components/Header";
import Menu from "../components/Menu";
import Notification from "../components/Notification";
import CardBox from "../components/CardBox";
//Style
import "./style.scss";
export default function Layout({ children }) {
    const newDate = +new Date();
    const confirmWarningIsExpired =
        (localStorage.getItem("confirmWarningExpiredDate") || newDate + 1000) <= newDate + 1000;
    const [showConfirm, setShowConfirm] = useState(confirmWarningIsExpired ? true : false);

    const ConfirmWarning = () => {
        setShowConfirm(false);
        localStorage.setItem("confirmWarningExpiredDate", +new Date() + 900 * 1000);
    };
    return (
        <>
            <div className="layout-main" style={showConfirm ? { filter: "blur(4px)" } : {}}>
                <Header />
                <div className="layout-main-content">
                    <Menu />
                    <div className="layout-main-content-page row">
                        <div className="col-md-2  p-15"></div>
                        <div className="col-md-8 p-15 layout-main-content-page-child">{children}</div>
                        <div className="col-md-2  p-15"></div>
                    </div>
                </div>

                <Notification />
            </div>
            {showConfirm && (
                <div className="warn-notification">
                    <CardBox title="Warning" onClickConfirmButton={ConfirmWarning} type="warning">
                        Since no information is stored by the user on the server and all operations are performed on the
                        client side, if you refresh the page, you will have to restore your wallet again in one of the
                        suggested ways.
                    </CardBox>
                </div>
            )}
        </>
    );
}
